import { gql, useQuery } from '@apollo/client';

export const GET_HOLIDAYS_GROUPS = gql`
  query getHolidaysGroups($queryOptions: QueryOptionsInput, $searchQuery: SearchQueryInput) {
    getHolidaysGroups(queryOptions: $queryOptions, searchQuery: $searchQuery) {
      collection {
        _id
        name
        holidayLocations {
          _id
          name
        }
      }
      totalCount
    }
  }
`;

export const useGetAllHolidaysGroups = () => {
  const { data, loading } = useQuery(GET_HOLIDAYS_GROUPS);

  const { totalCount = 0, collection = [] } = data?.getHolidaysGroups || {};

  return { holidaysGroups: collection, loading, totalCount };
};
